const isVisitActual = (visit) => visit.status !== 'cancelled' && visit.status !== 'completed'

export default isVisitActual
